// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3sO3N","productName":"Table_productName__DUa6C"};